export enum ExpressionValueType {
    UNSET = "unset",
    VARIABLE = "variable",
    VALUE = "value",
    SUBEXPRESSION = "subexpression",
}

export enum StringExpressionValueType {
    SHORT = "short",
    LONG = "long",
    MERGE = "merge",
}

export enum ObjectExpressionValueType {
    CONSTANT = "constant",
    MAPPED = "mapped",
}
